/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext } from 'react';
import ModifySearchContext from '../ModifySearchContext';

const LOCATION_ICON_URL = 'https://jsak.mmtcdn.com/holidays/rn/images/0c5c8e6a_locationIcon.webp';

const InputBox = ({
  children,
  name,
  value,
  label,
  onFocus,
  disableInput,
  tooltipText,
  showLocationIcon = false,
  icon,
}) => {
  const { activeControl, setActiveControl } = useContext(ModifySearchContext);
  const isActive = activeControl === name;
  const allInactive = activeControl === null;
  const id = name.split(' ').join('–');
  const handleOnFocus = () => {
    if (!disableInput) {
      setActiveControl(name);
      if (onFocus) onFocus();
    }
  };
  return (
    <div className={`modify-search_inputbox ${isActive || allInactive ? 'active' : ''}`}>
      {showLocationIcon && (
        <span className="locationIcon">
          <img width={24} src={LOCATION_ICON_URL} />
        </span>
      )}
      {!!icon && typeof icon === 'string' && <span className={`icon ${icon}`} />}
      <div>
        <div className="makeFlex">
          <label htmlFor={id} className="modify-search_inputlbl">
            {label}
          </label>
          {disableInput && (
            <>
              <span className="inputTooltipInfoIcon">&#9432;</span>
              {disableInput && (
                <div
                  className="inputTooltipInfoMessage"
                  dangerouslySetInnerHTML={{ __html: tooltipText }}
                />
              )}
            </>
          )}
        </div>
        <input
          id={id}
          name={name}
          type="text"
          className={`modify-search_input ${disableInput ? 'disabled' : ''}`}
          value={value}
          onFocus={handleOnFocus}
          readOnly
          placeholder="Select"
        />
      </div>
      {isActive && children}
    </div>
  );
};

export default InputBox;
